import { render } from "./WCItemModifierItem.vue?vue&type=template&id=8d76a2d2&scoped=true"
import script from "./WCItemModifierItem.vue?vue&type=script&lang=js"
export * from "./WCItemModifierItem.vue?vue&type=script&lang=js"

import "./WCItemModifierItem.vue?vue&type=style&index=0&id=8d76a2d2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d76a2d2"]])

export default __exports__